import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiPut, apiRemove } from 'api-service';
import { toast } from 'lib';
import { t } from 'i18next';

export const getCities = createAsyncThunk(
  'brandBuilderSlice/getCities',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/brand-identity/counties', {
        ...params,
      });

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getBrandBaanEntitiesList = createAsyncThunk(
  'brandBuilderSlice/getBrandBaanEntitiesList',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/brand-identity/entities', {
        ...params,
      });

      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getIndustriesList = createAsyncThunk(
  'brandBuilderSlice/getIndustriesList',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/brand-identity/entities', {
        entity_types: ['industry'],
        ...params,
      });

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSectorsList = createAsyncThunk(
  'brandBuilderSlice/getSectorsList',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/brand-identity/entities', {
        entity_types: ['sector'],
        ...params,
      });

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getBrandBaanCompetitiors = createAsyncThunk(
  'brandBuilderSlice/getBrandBaanCompetitiors',
  async ({ entityId }, thunkAPI) => {
    try {
      const response = await apiGet(
        `/search/api/v1/brand-identity/entities/${entityId}/edges/competitors`
      );

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getBrandBaanCompetitiorSuggestions = createAsyncThunk(
  'brandBuilderSlice/getBrandBaanCompetitiorSuggestions',
  async ({ entityId, ...params }, thunkAPI) => {
    try {
      const response = await apiGet(
        `/search/api/v1/brand-identity/entities/${entityId}/edges/suggestions`,
        {
          ...params,
        }
      );

      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeBrandBaanCompetitior = createAsyncThunk(
  'brandBuilderSlice/removeBrandBaanCompetitior',
  async ({ entityId, competitorId }, thunkAPI) => {
    try {
      const response = await apiRemove(
        `/search/api/v1/brand-identity/entities/${entityId}/edges`,
        {
          competitor_id: competitorId,
        }
      );

      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addBrandBaanCompetitior = createAsyncThunk(
  'brandBuilderSlice/addBrandBaanCompetitior',
  async ({ entityId, competitors }, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${entityId}/edges`,
        {
          competitors: [...competitors],
        }
      );

      return response?.data?.result;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editBrandBaanEntity = createAsyncThunk(
  'brandBuilderSlice/editBrandBaanEntity',
  async ({ entityId, params }, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${entityId}?_method=PUT`,
        params
      );
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeBrandBaanEntity = createAsyncThunk(
  'brandBuilderSlice/removeBrandBaanEntity',
  async ({ entityId }, thunkAPI) => {
    try {
      const response = await apiRemove(
        `/search/api/v1/brand-identity/entities/${entityId}`
      );
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addBrandBaanEntitiy = createAsyncThunk(
  'brandBuilderSlice/addBrandBaanEntitiy',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost(
        '/search/api/v1/brand-identity/entities',
        params
      );
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addBrandBaanProfilesOrSubject = createAsyncThunk(
  'brandBuilderSlice/addBrandBaanProfilesOrSubject',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${params.entity_id}/shares`,
        {
          ...params,
        }
      );
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addBrandBaanDepartment = createAsyncThunk(
  'brandBuilderSlice/addBrandBaanDepartment',
  async ({ entityId, departmentId }, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${entityId}/department`,
        {
          department_id: departmentId,
        }
      );
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        title: t('common:error.fallback.description'),
        type: 'error',
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const activeBrandBaanEntity = createAsyncThunk(
  'brandBuilderSlice/activeBrandBaanEntityStatus:',
  async ({ entityId, force }, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${entityId}/ready`,
        {
          force: force ? 1 : undefined,
        }
      );

      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response.data.errors.data.errors.entity
      );
    }
  }
);

export const searchDigikalaBrands = createAsyncThunk(
  'brandBuilderSlice/searchDigikalaBrands',
  async ({ q } = {}, thunkAPI) => {
    const searchQuery = typeof q === 'string' ? q : '';

    try {
      const response = await apiGet('/search/api/v1/search', {
        api_path: '/digikala/brands',
        q: searchQuery,
        full_text: 1,
      });

      const brands = response?.data?.result?.data || [];

      return brands
        .filter((brand) => brand.resource_brand_code)
        .map((brand) => ({
          code: brand.resource_brand_code,
          title: brand.resource_brand_title,
          logo: brand.resource_brand_logo,
        }));
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addEcommerceBrandCode = createAsyncThunk(
  'brandBuilderSlice/addEcommerceBrandCode',
  async ({ entityId, code }, thunkAPI) => {
    try {
      const response = await apiPost(
        `/search/api/v1/brand-identity/entities/${entityId}/ecommerce-brand-codes`,
        { code }
      );
      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editEcommerceBrandCode = createAsyncThunk(
  'brandBuilderSlice/editEcommerceBrandCode',
  async ({ entityId, codeId, code }, thunkAPI) => {
    try {
      const response = await apiPut(
        `/search/api/v1/brand-identity/entities/${entityId}/ecommerce-brand-codes/${codeId}`,
        { code }
      );
      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeEcommerceBrandCode = createAsyncThunk(
  'brandBuilderSlice/removeEcommerceBrandCode',
  async ({ entityId, codeId }, thunkAPI) => {
    try {
      const response = await apiRemove(
        `/search/api/v1/brand-identity/entities/${entityId}/ecommerce-brand-codes/${codeId}`
      );
      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
